import {mapMutations, mapGetters} from "vuex";
import {rePostionContents, reSizeIeBackground, reSizeBackground} from "@/utils/cavasResize";

export default{
    data() {
        return {
            canvas: null,
            cvObj: {},
            cvFilters:{},
            contentSize:{w:1920, h:1080},
            enterMotion: null,
            leaveMotion: null,
            bgPlayer:null
        };
    },
    computed:{
        ...mapGetters([
          'activeLayer',
          'documentSize',
        ])
    },
    methods: {
        ...mapMutations([
            'changePage',
            'isMovePage',
            'isLayerView',
            'documentSetSize',
        ]),
        baseCavasSet(option){
            if(this.documentSize.width == 0 || this.documentSize.width == undefined){
                this.documentSetSize({
                    width: document.querySelector('.container').clientWidth,
                    height:document.querySelector('.container').clientHeight
                });
            }
            this.canvas = new PIXI.Application(this.documentSetSize.width, this.documentSetSize.height, {transparent:true,  autoStart:true}); //forceCanvas:this.$isIe11,
            this.$el.querySelector('.bg').appendChild(this.canvas.view);
            option.forEach(obj=>{
                let type = obj.type;
                switch(type) {
                    case 'bg': {
                        if(obj.objName == 'bg'){
                            this.cvObj.bg = PIXI.Sprite.fromImage(obj.source);
                        }else{
                                this.cvObj.bgTexture = PIXI.Texture.fromVideo(obj.source);
                                this.cvObj.bgTexture.baseTexture.source.loop = true;
                                this.cvObj.bgTexture.baseTexture.source.muted = true;
                                let conAreaBg = new PIXI.Graphics(0, 0);
                                conAreaBg.alpha = 0;
                                conAreaBg.drawRect(0, 0, this.documentSetSize.width, this.documentSetSize.height);


                                this.cvObj.bg = new PIXI.Sprite(this.cvObj.bgTexture);
                                this.cvObj.bg.addChild(conAreaBg);

                        }
                        reSizeBackground(this.cvObj.bg, this.documentSetSize.width, this.documentSetSize.height);
                        this.canvas.stage.addChild(this.cvObj.bg);

                        this.cvFilters.ZoomBlurFilter =  new PIXI.filters.ZoomBlurFilter();
                        this.cvFilters.ZoomBlurFilter.strength = 0.5;
                        this.cvFilters.ZoomBlurFilter.center = [this.documentSetSize.width/2, this.documentSetSize.height/2];
                        this.cvFilters.ZoomBlurFilter.innerRadius = 0;
                        this.canvas.stage.filters = [this.cvFilters.ZoomBlurFilter];



                        break;
                    }
                    case 'bgChrCon':{
                        this.cvObj.bgChrCon = new PIXI.Container();
                       // reSizeBackground(this.cvObj.bgChrCon, this.documentSetSize.width, this.documentSetSize.height);
                        this.canvas.stage.addChild(this.cvObj.bgChrCon);
                        break;
                    }
                    case 'bgCover':{
                        this.cvObj.bgCover = PIXI.Sprite.fromImage(obj.source);
                        reSizeBackground(this.cvObj.bgCover, this.documentSetSize.width, this.documentSetSize.height);
                        this.canvas.stage.addChild(this.cvObj.bgCover);

                        break;
                    }
                }
                this.cvObj.con = new PIXI.Container();
                this.cvObj.con.x = this.documentSetSize.width/2 - this.contentSize.w/2;
                this.cvObj.con.y = 0;
                this.canvas.stage.addChild(this.cvObj.con);
                let conArea = new PIXI.Graphics(this.documentSetSize.width/2 - this.contentSize.w/2, 0);
                conArea.alpha = 0;
                conArea.drawRect(0, 0, this.contentSize.w, this.contentSize.h);
                this.cvObj.con.addChild(conArea);
            });

            this.canvas.ticker.add(()=> {
                //this.cvFilters.ZoomBlurFilter.speed = Math.random();
             });


         },
        baseEnterMotion(el, done, option){

            this.$el.classList.add('enter')
            this.enterMotion = new TimelineLite({onComplete:()=>{
                done();
            }, paused:true});
            option.forEach(obj=> {
                let type = obj.type;
                let delay;
                switch (type) {
                    case 'bg': {
                        TweenMax.set(this.cvObj.bg, {pixi: { alpha: 0.1} });
                        if(this.cvObj.ieBg)TweenMax.set(this.cvObj.ieBg, {autoAlpha: 0 });
                        this.enterMotion
                            .to(this.cvFilters.ZoomBlurFilter,1, {strength:0, ease:Cubic.easeIn},'+=0')
                            .to(this.cvObj.bg, 1, {pixi: { alpha: 1}, ease: Quart.easeIn},'-=1')
                            .call(()=>{
                                this.isMovePage(false);
                                this.$el.classList.remove('enter');
                                this.canvas.stage.filters = null;
                                }, null, null)
                            .addLabel('bgMotionEnd')
                            if(this.cvObj.ieBg){
                                this.enterMotion.to(this.cvObj.ieBg, 2,{autoAlpha: 1 }, 'bgMotionEnd-=1.5')
                            }
                        break;
                    }

                }
            });
            //GSDevTools.create({paused:true, id:this.name});
        },
        baseLeaveMotion(el, done){
            this.$el.classList.add('leave')
            if(this.cvObj.bgTexture)this.cvObj.bgTexture.baseTexture.source.pause();
            if(this.cvObj.ieBg)this.cvObj.ieBg.pause();


            this.leaveMotion = new TimelineLite({onComplete:()=>{
                    done();
                    this.canvas.stop();
                }
            });
            this.leaveMotion
                //.to(this.cvFilters.ZoomBlurFilter, 1, {strength:0.5, ease: Cubic.easeIn})
                .to(this.$el, 0.5, {autoAlpha:0})
        },
        baseEnter(){
            window.addEventListener('resize', this.resize);
            this.resize();
        },
        beforeEnter(el){
        },
        enter (el, done) {
            this.baseEnter();
        },
        leave (el, done) {
            window.removeEventListener('resize', this.resize);
        },
        resize(){
            this.documentSetSize.width =  document.querySelector('.container').clientWidth;
            this.documentSetSize.height = document.querySelector('.container').clientHeight;
            if(!this.canvas)return;
            reSizeBackground(this.cvObj.bg, this.documentSetSize.width, this.documentSetSize.height);
            rePostionContents(this.cvObj.con, this.documentSetSize.width, this.documentSetSize.height, this.contentSize.w, this.contentSize.h, true);
            this.canvas.renderer.resize(this.documentSetSize.width, this.documentSetSize.height);

        },
        openLayer(e) {
            this.isLayerView(e.currentTarget.name);
        },
        handleTransitionStart() {
            this.layerData[this.activeLayer].index = this.$refs[this.activeLayer].now();
        },
        handleTransitionEnd() {
          this.layerData[this.activeLayer].index = this.$refs[this.activeLayer].now();
          window.nowPlayingVideo && window.nowPlayingVideo.stop();
        },
        handleClickTo(index) {
            this.$refs[this.activeLayer].to(index);
        },
    },
    mounted() {
        this.changePage(this.$options.name);
        this.isMovePage(true);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resize);
    }
    // beforeRouteEnter  (to, from, next) {
    //     next();
    // },
    // beforeRouteLeave (to, from, next) {
    //     next();
    // }
}